import PropTypes from "prop-types";

import Row from "../Row";
import React from "react";
import Tools from "../../../helpers/tools";

const EntitlementRows = ({entitled, claimedBy, claimedOn}) => {
    const tooltipDescription = Tools.getOriginDescription(claimedBy);
    return (
        <>
            <Row label={`Entitlement`} empty/>
            <Row label={`Entitled`}
                 value={Tools.booleanToString(entitled)}
                 indented/>
            <Row label={`Claimed by`} value={entitled && claimedBy} indented>
                {
                    tooltipDescription && entitled && claimedBy ?
                        <span
                            className={`fa fa-info-circle vehicle-connected`}
                            aria-hidden="true"
                            title={tooltipDescription}
                        /> : ``
                }
            </Row>
            <Row label={`Claimed on`} value={entitled && claimedOn} indented/>
        </>
    );
};

EntitlementRows.displayName = `EntitlementRows`;
EntitlementRows.propTypes = {
    entitled: PropTypes.bool.isRequired,
    claimedBy: PropTypes.string.isRequired,
    claimedOn: PropTypes.string.isRequired
};
export default EntitlementRows;